// Helper central de eventos para a landing de Projetos Corporativos.
// Reutiliza o GA4 (window.gtag) já configurado no index.html e o dataLayer,
// sem inventar novos IDs de Analytics/Ads.

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...(params ?? {}) });

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params ?? {});
  }
}